import { render, staticRenderFns } from "./VCheck.vue?vue&type=template&id=6c4e4c16&scoped=true"
import script from "./VCheck.vue?vue&type=script&lang=js"
export * from "./VCheck.vue?vue&type=script&lang=js"
import style0 from "./VCheck.vue?vue&type=style&index=0&id=6c4e4c16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c4e4c16",
  null
  
)

export default component.exports